<app-street-light-planner-step2-manual> </app-street-light-planner-step2-manual>
